<template>
  <div>
    <div id="CustomerMostVariantReportChart"></div>
  </div>
</template>

<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);

export default {
  name: "CustomerMostVariantReportChart",
  props: {
    chartData: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      chart: null,
      noDataLabel: null,
      colors: ["#ACF9FF", "#F2809F", "#80F2AC", "#80B2EF", "#F2BC80", "#F099F7"],
      innerLabel: null,
    };
  },
  watch: {
    chartData: {
      handler(newData) {
        this.updateChart(newData);
      },
      immediate: true,
    },
  },
  mounted() {
    this.createChart();
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
      this.chart = null;
    }
  },
  methods: {
    createChart() {
      this.chart = am4core.create("CustomerMostVariantReportChart", am4charts.PieChart);
      this.chart.innerRadius = am4core.percent(96);

      let pieSeries = this.chart.series.push(new am4charts.PieSeries());
      pieSeries.dataFields.value = "value";
      pieSeries.dataFields.category = "label";
      pieSeries.slices.template.propertyFields.fill = "color";

      pieSeries.labels.template.disabled = true;
      pieSeries.ticks.template.disabled = true;

      pieSeries.slices.template.tooltipText =
        "{category}: {value} ({value.percent.formatNumber('#.0')}%)";
      pieSeries.tooltip.getFillFromObject = false;
      pieSeries.tooltip.background.fill = am4core.color("#fff");
      pieSeries.tooltip.label.fill = am4core.color("#000");
      pieSeries.tooltip.background.strokeWidth = 1;
      pieSeries.tooltip.background.stroke = am4core.color("#ccc");
      pieSeries.tooltip.background.pointerLength = 0;

      // Disable hover and click effects
      let hoverState = pieSeries.slices.template.states.getKey("hover");
      hoverState.properties.scale = 1;
      hoverState.properties.shiftRadius = 0;

      pieSeries.slices.template.clickable = false;
      pieSeries.slices.template.hoverable = false;

      // this.chart.legend = new am4charts.Legend();
      // this.chart.legend.position = "bottom";
      // this.chart.legend.valueLabels.template.disabled = true;
      // this.chart.legend.dataFields.name = "label";
      // this.chart.legend.maxWidth = am4core.percent(100);
      // this.chart.legend.contentAlign = "center";
      // this.chart.legend.useDefaultMarker = true;
      // this.chart.legend.labels.template.maxWidth = 150;
      // this.chart.legend.itemContainers.template.marginBottom = 5;
      // this.chart.legend.itemContainers.template.wrap = true;
      // this.chart.legend.layout = "grid";
      // this.chart.legend.itemContainers.template.width = am4core.percent(33);
      // this.chart.legend.itemContainers.template.marginRight = 10;
      // this.chart.legend.itemContainers.template.marginLeft = 10;

      this.chart.legend = new am4charts.Legend();
      this.chart.legend.layout = "grid";
      this.chart.legend.position = "bottom";
      this.chart.legend.valueLabels.template.disabled = true;
      this.chart.legend.dataFields.name = "label";

      // Let legend stretch with the chart container
      this.chart.legend.width = am4core.percent(100);
      this.chart.legend.contentAlign = "center";

      // Let amCharts handle item width automatically (no fixed %)
      this.chart.legend.itemContainers.template.width = undefined;

      this.chart.legend.labels.template.wrap = true;
      this.chart.legend.labels.template.truncate = false;

      this.chart.legend.maxColumns = 2;

      this.chart.legend.itemContainers.template.valign = "middle";

      this.chart.legend.marginBottom = 10;
      this.chart.legend.marginTop = 10;

      this.innerLabel = this.chart.seriesContainer.createChild(am4core.Label);
      this.innerLabel.horizontalCenter = "middle";
      this.innerLabel.verticalCenter = "middle";
      this.innerLabel.fontSize = 20;
      this.innerLabel.textAlign = "middle";
      this.innerLabel.wrap = true;
      this.innerLabel.maxWidth = 200;

      this.createNoDataLabel();
      this.updateChart(this.chartData);
    },
    createNoDataLabel() {
      if (!this.chart) return;

      this.noDataLabel = this.chart.createChild(am4core.Label);
      this.noDataLabel.align = "center";
      this.noDataLabel.valign = "middle";
      // this.noDataLabel.paddingBottom = 30;
      this.noDataLabel.verticalCenter = "middle";
      this.noDataLabel.horizontalCenter = "middle";
      this.noDataLabel.role = "noDataLabel";
      this.noDataLabel.x = am4core.percent(50);
      this.noDataLabel.y = am4core.percent(50);
      this.noDataLabel.isMeasured = false;
      this.noDataLabel.html = `
        <div class="chart-no-data">
          <span>0</span>
          <span>No Data</span> 
        </div>
        `;
      this.noDataLabel.hide();
    },
    toggleNoDataLabel(data) {
      const hasData = data && data.some((item) => parseInt(item.value, 10) > 0);

      if (!hasData) {
        this.noDataLabel.show();
        this.chart.seriesContainer.hide();
        this.chart.data = [];
        this.chart.legend.hide();
      } else {
        this.noDataLabel.hide();
        this.chart.seriesContainer.show();
        this.chart.legend.show();
      }
    },
    // updateChart(data = this.chartData) {
    //   if (!this.chart) return;

    //   let mappedData = data.map((item, index) => ({
    //     label: item.variant,
    //     value: parseInt(item.total_variant, 10),
    //     color: this.colors[index % this.colors.length],
    //   }));

    //   this.toggleNoDataLabel(mappedData);
    //   this.chart.data = mappedData;
    //   this.chart.legend.data = mappedData.filter((item) => item.value > 0);

    //   let total = mappedData.reduce((sum, item) => sum + item.value, 0);
    //   let highest = mappedData.reduce(
    //     (prev, current) => (current.value > prev.value ? current : prev),
    //     { label: "", value: 0 }
    //   );

    //   this.innerLabel.text =
    //     highest.value > 0
    //       ? `[bold]${highest.label}[/]\n${(
    //           (highest.value / total) *
    //           100
    //         ).toFixed(2)}%`
    //       : "";
    // },
    updateChart(data = this.chartData) {
      if (!this.chart) return;

      let rawMapped = data.map((item) => ({
        label: item.variant,
        value: parseInt(item.total_variant, 10),
      }));

      rawMapped.sort((a, b) => b.value - a.value);

      const topItems = rawMapped.slice(0, 5);
      const others = rawMapped.slice(5);

      if (others.length > 0) {
        const othersTotal = others.reduce((sum, item) => sum + item.value, 0);
        topItems.push({ label: "Lainnya", value: othersTotal });
      }

      let mappedData = topItems.map((item, index) => ({
        ...item,
        color: this.colors[index % this.colors.length],
      }));

      this.toggleNoDataLabel(mappedData);
      this.chart.data = mappedData;

      this.chart.legend.data = mappedData.filter((item) => item.value > 0);

      let total = mappedData.reduce((sum, item) => sum + item.value, 0);
      let highest = mappedData.reduce(
        (prev, current) => (current.value > prev.value ? current : prev),
        { label: "", value: 0 }
      );

      this.innerLabel.text =
        highest.value > 0
          ? `[bold]${highest.label}[/]\n${((highest.value / total) * 100).toFixed(2)}%`
          : "";
    },
  },
};
</script>

<style>
#CustomerMostVariantReportChart {
  width: 100%;
  height: 400px;
  transform: translate3d(0, 0, 0);
}

#CustomerMostVariantReportChart g[aria-label="Chart"] + g g[aria-labelledby] {
  opacity: 0;
}

#CustomerMostVariantReportChart .chart-no-data {
  width: 220px;
  height: 220px;
  border-radius: 50%;
  border: 16px solid #d8d8d8;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-size: 24px;
  font-weight: 600;
}

#CustomerMostVariantReportChart .chart-no-data span:first-child {
  font-size: 48px;
  font-weight: 700;
}
</style>
